import toastr from 'react-hot-toast';
import { useQuery } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { CACHE_AND_STALE_TIME } from 'constants/index';
import { generateURL } from 'utilities/hooks/urlGeneration';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import type { SingleMemoryDiagnosticsResponse } from 'types/Memory/MemoryDiagnostics';

const getMemoryDiagnostics = (memoryID: string | undefined | null) => {
  const url = generateURL(
    SPARK_RESOURCE_TYPES.MEMORY_DIAGNOSTICS,
    [],
    memoryID
  );
  return fetchWrapper<SingleMemoryDiagnosticsResponse>({
    url,
    method: 'GET',
  });
};

export function useMemoryDiagnostics(memoryID: string | undefined | null) {
  //   const queryClient = useQueryClient();
  //   const queries = queryClient.getQueryCache().getAll();

  //   const filteredQuery = queries.find((query) => {
  //     const expectedQueryKey = JSON.stringify(['sparkSteps', memoryID]);
  //     return query.queryHash === expectedQueryKey;
  //   });

  const response = useQuery(
    ['memoryDiagnostics', memoryID],
    () => getMemoryDiagnostics(memoryID),
    {
      onError: (error) => {
        if (error instanceof Error) {
          toastr.error(`failed to Fetch Memory Diagnostics: ${error.message}`);
        }
      },
      //   enabled: Boolean(memoryID && !!filteredQuery?.state.data),
      enabled: !!memoryID,
      ...CACHE_AND_STALE_TIME,
    }
  );
  const { data: memoryResponse } = response || [];
  const { data: memory } = memoryResponse || {};

  return {
    memory,
    memoryDiagnostics: memory?.meta,
    ...response,
  };
}
